import React from "react"
import { AutocompleteAjaxSeeker, IconSeeker } from "@ui-seeker/core"

import { BACKEND_APIS } from "@constants"
import { useAlertsDataInfo } from "Pages/ReportsAlerts/Alerts/Conditions/@hooks"
import { alertsDrawerData } from "Pages/ReportsAlerts/Alerts/Conditions/@signals"
import { Box, Typography } from "@mui/material"
import { dsColorNew } from "@palette"


export default function Comparator({ ...props }) {

	const { dataInfo, setDataInfo } = useAlertsDataInfo(alertsDrawerData.peek().comparator || 0)

	const labelsFormatted = {
		2: { icon: "not-equal", label: "Different than", color: dsColorNew.noteAmber },
		1: { icon: "greater-than", label: "Greater than", color: dsColorNew.successText },
		0: { icon: "less-than", label: "Less than", color: dsColorNew.dangerRed }
	}

	return <AutocompleteAjaxSeeker
		filterSelectedOptions={false} 
		disableClearable
		label="Comparator"
		placeholder="Way of comparison"
		urlAjax={`${BACKEND_APIS.MASTER_DATA}/all/options/comparator_rating`}
		inputProps={{
			startAdornment: <IconSeeker
				icon={labelsFormatted[dataInfo.value].icon}
				sx={{
					color: labelsFormatted[dataInfo.value].color,
					ml: 1,
					mr: .5
				}}
			/>
		}}
		onAjax={options => {
			return options.map(({ value }) => ({
				value: value,
				label: labelsFormatted[value].label,
			}))
		}}
		formatOptionLabel={({ value }) => {
			return <Box sx={{ display: "flex", alignItems: "center", justifyContent: "center", gap: 1 }}>
				<IconSeeker
					icon={labelsFormatted[value].icon}
					sx={{ color: labelsFormatted[value].color }}
				/>
				<Typography>{labelsFormatted[value].label}</Typography>
			</Box>
		}}
		value={dataInfo.value}
		onChange={e => setDataInfo(e.target.value, 'comparator')}
		{...props}
	/>
}